import React from "react";
import { HiOutlineVideoCamera } from "react-icons/hi2";
import { MdOutlineLeaderboard } from "react-icons/md";
import { MdOutlineSportsBaseball } from "react-icons/md";
import { FaClockRotateLeft } from "react-icons/fa6";
// import { HiChartBar } from "react-icons/hi";
import { LuChartLine, LuSmartphone } from "react-icons/lu";
import "./ScoringPage.scss";

const proFeatures = [
  {
    icon: MdOutlineSportsBaseball,
    title: "Ball-by-Ball Scoring",
    description: "Quick input panel with runs, extras,and wicket options. Log every delivery with just a single tap.",
  },
  {
    icon: MdOutlineLeaderboard,
    title: "Live Scorecards",
    description: "Auto-updating batting & bowling stats. Real-time insights into strike rates, economy, and session progression.",
  },
  {
    icon: LuChartLine,
    title: "Performance Analytics",
    description: "Run rate graphs, partnerships, and momentum analysis. Visualize the game's flow with pro-grade charts.",
  },
  {
    icon: HiOutlineVideoCamera,
    title: "Streaming Integration",
    description: "Stream matches with live score overlay integration. Broadcast to YouTube and Facebook witt professional graphics.",
  },
  {
    icon: LuSmartphone,
    title: "Mobile Friendly",
    description: "Score from anywhere, optimized for any device. Offline mode ensures younever lose a ball during connectivity drops.",
  },
  {
    icon: FaClockRotateLeft,
    title: "Undo & Edit Control",
    description: "Correct mistakes instantly with granular control. Easily navigate  through the match history to rectify scoring errors.",
  },
];

const ScoringPage: React.FC = () => {
  return (
    <div className="scoring-page">
      <section className="scoring-hero">
        <div className="scoring-hero-content">
          <div className="scoring-hero-text">
            <h1 className="scoring-hero-title">
              Score Cricket Matches{" "}
              <span className="scoring-hero-accent">Live</span>. Fast. Simple. Accurate.
            </h1>
            <p className="scoring-hero-description">
              Run tournaments, manage teams, and stream live scores in real-time with our powerful cricket scoring system. Built for enthusiasts, professionals, and everyone in between.
            </p>
          </div>
        </div>
      </section>

      <section className="scoring-pro-features">
        <div className="scoring-pro-features-inner">
          <div className="scoring-pro-features-header">
            <span className="scoring-pro-features-badge">PRO FEATURES</span>
            <h2 className="scoring-pro-features-title">
              Everything You Need to Score Like a Pro
            </h2>
            <p className="scoring-pro-features-description">
              Advanced tools designed for professional cricket scoring and real-time match analysis, used by leagues and academies worldwide.
            </p>
          </div>
          <div className="scoring-pro-features-grid">
            {proFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <article key={index} className="scoring-feature-card">
                  <div className="scoring-feature-card-icon">
                    <Icon />
                  </div>
                  <div className="scoring-feature-card-content">
                    <h3 className="scoring-feature-card-title">{feature.title}</h3>
                    <p className="scoring-feature-card-description">{feature.description}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="scoring-cta">
        <div className="scoring-cta-inner">
          <h2 className="scoring-cta-title">Ready to elevate your game coverage?</h2>
          <p className="scoring-cta-description">
            Join over 5,000+ clubs and leagues scoring with CricCenter every weekend.
          </p>
          <button type="button" className="scoring-cta-button">
            Download our app and start scoring
          </button>
        </div>
      </section>
    </div>
  );
};

export default ScoringPage;
